import {space} from '../space';
import {typographyTokens as typography} from '../sizing';
import {opacityTokens as opacities} from '../opacities';

type UnifiedControls = {
  height?: string;
  fontSize?: string;
  gutter?: string;
  lineHeight?: string;
};

export type Controls = UnifiedControls & {
  heightXLarge: string;
  heightLarge: string;
  heightMedium: string;
  borderRadius: string;
  borderWidth: string;
  fontSizeLarge: string;
  fontSizeMedium: string;
  fontSizeXLarge: string;
  gutterLarge: string;
  gutterMedium: string;
  gutterXLarge: string;
  lineHeightLarge: string;
  lineHeightMedium: string;
  lineHeightXLarge: string;
  opacityDisabled: string | number;
};

const borderWidth = '1px';

const heights = {
  heightLarge: '32px',
  heightMedium: '24px',
  heightXLarge: '40px',
} as const;

export const controls: Controls = {
  ...heights,
  borderRadius: '2px', // should be using borders.radius directly
  borderWidth: '1px',
  fontSizeLarge: typography.fontSize.body,
  fontSizeMedium: typography.fontSize.body,
  fontSizeXLarge: typography.fontSize.body,
  gutterLarge: space[3],
  gutterMedium: space[2],
  gutterXLarge: space[3],
  lineHeightLarge: `calc(${heights.heightLarge} - ${borderWidth} * 2)`,
  lineHeightMedium: `calc(${heights.heightMedium} - ${borderWidth} * 2)`,
  lineHeightXLarge: `calc(${heights.heightXLarge} - ${borderWidth} * 2)`,
  opacityDisabled: opacities.disabled,
};

export const controlTokens: Controls = {
  borderRadius: 'var(--controls-border-radius)', // should be using borders.radius directly
  borderWidth: 'var(--controls-border-width)',
  fontSizeLarge: 'var(--controls-font-size-large)', // typography.fontSize.body
  fontSizeMedium: 'var(--controls-font-size-medium)', // typography.fontSize.body
  fontSizeXLarge: 'var(--controls-font-size-x-large)', // typography.fontSize.body
  gutterLarge: 'var(--controls-gutter-large)',
  gutterMedium: 'var(--controls-gutter-medium)',
  gutterXLarge: 'var(--controls-gutter-x-large)',
  heightLarge: 'var(--controls-height-large)',
  heightMedium: 'var(--controls-height-medium)',
  heightXLarge: 'var(--controls-height-x-large)',
  lineHeightLarge: 'var(--controls-line-height-large)',
  lineHeightMedium: 'var(--controls-line-height-medium)',
  lineHeightXLarge: 'var(--controls-line-height-x-large)',
  opacityDisabled: 'var(--controls-opacity-disabled)',
};
